import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';
import { IVideoTime } from '~/types/sanity-objects';
import { IEpisode } from '~/types/series';
import { useStore } from '~/store/composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectEpisode',
  props: {
    episode: null,
    projectSlug: null
  },
  setup(__props: any) {

const props = __props as {
  episode: IEpisode;
  projectSlug: string;
};



const { i18n } = useContext();

const { getters, state } = useStore();

const playIcon = require('@/assets/icons/play_icon.svg');

const hasStartedEpisode = computed(
  () =>
    episodeWatchProgress.value &&
    episodeWatchProgress.value.percentageWatched > 0,
);

const userId = computed(() => state.profile?.user?.id);

const timeRemaining = computed(() => {
  if (!props.episode.runTime) return undefined;

  const hours = Math.floor(timeRemainingInSeconds.value / 3600);
  const minutes = Math.floor((timeRemainingInSeconds.value % 3600) / 60);

  if (hours > 0) {
    const remainingRunTime: IVideoTime = {
      hours,
      minutes,
    };
    return remainingRunTime;
  }

  const remainingRunTime: IVideoTime = {
    minutes,
  };

  return remainingRunTime;
});

const runTimeInSeconds = computed(() => {
  if (!props.episode.runTime) return 0;

  const runTime = props.episode.runTime;

  const minutes = ((runTime.hours ?? 0) * 60 + (runTime.minutes ?? 0)) * 60;

  return minutes + (runTime.seconds ?? 0);
});

const timeRemainingInSeconds = computed(() => {
  return episodeWatchProgress.value?.secondsRemaining ?? 0;
});

const videoIsWatched = computed(() => {
  return episodeWatchProgress.value?.watched ?? false;
});

const percentageWatched = computed(() => {
  return episodeWatchProgress.value?.percentageWatched ?? 0;
});

const timeRemainingText = computed(() => {
  if (!timeRemaining.value) return '';

  return formatRunTime(timeRemaining.value);
});

const filmRunTimeText = computed(() => {
  if (!props.episode.runTime) return '';

  return formatRunTime(props.episode.runTime);
});

function formatRunTime(runTime: IVideoTime) {
  if (runTime.hours) {
    return i18n.t('components.films.filmOverview.durationWithHours', {
      h: runTime.hours,
      m: runTime.minutes,
    });
  }

  return i18n.t('components.films.filmOverview.duration', {
    m: runTime.minutes,
  });
}

const episodeWatchProgress = computed(() => {
  const episodeWatchProgress = getters[
    'projects/getProjectEpisodeWatchProgress'
  ](props.projectSlug);
  return episodeWatchProgress?.[props.episode.slug];
});

return { __sfc: true,props, i18n, getters, state, playIcon, hasStartedEpisode, userId, timeRemaining, runTimeInSeconds, timeRemainingInSeconds, videoIsWatched, percentageWatched, timeRemainingText, filmRunTimeText, formatRunTime, episodeWatchProgress }
}

})